import Image from 'next/image';
import {
  ContentSection,
  HeroDescription,
  heroImageStyle,
  HeroOverlay,
  HeroSection,
  HeroTitle,
} from '@/styles/hoian-travel-guide-page-style';

type PageHeroIntroProps = {
  title?: string;
  description?: string;
  heroImageSrc?: string;
  heroImageAlt?: string;
};

const PageHeroIntro = ({
  title,
  description,
  heroImageSrc = '/assets/images/2369425270.jpeg',
  heroImageAlt = 'HoiAnGO',
}: PageHeroIntroProps) => {
  return (
    <>
      <HeroSection>
        <Image
          src={heroImageSrc}
          alt={heroImageAlt}
          fill
          priority
          sizes="100vw"
          style={heroImageStyle}
        />
        <HeroOverlay />
      </HeroSection>
      <ContentSection>
        <HeroTitle>{title ?? ''}</HeroTitle>
        <HeroDescription>{description ?? ''}</HeroDescription>
      </ContentSection>
    </>
  );
};

export default PageHeroIntro;
